export default "__VITE_ASSET__1f9f700b__"